var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9992 25.8816V30.3816C33.0009 30.7994 32.9153 31.2129 32.7479 31.5956C32.5806 31.9784 32.3351 32.322 32.0273 32.6044C31.7195 32.8868 31.356 33.1018 30.9603 33.2357C30.5646 33.3695 30.1452 33.4192 29.7292 33.3816C25.1134 32.8801 20.6797 31.3028 16.7842 28.7766C13.1599 26.4736 10.0872 23.4009 7.78417 19.7766C5.24913 15.8634 3.67153 11.4081 3.17917 6.77161C3.14168 6.35681 3.19098 5.93875 3.32392 5.54405C3.45686 5.14934 3.67052 4.78664 3.95132 4.47904C4.23211 4.17144 4.57387 3.92567 4.95485 3.75739C5.33583 3.58911 5.74768 3.502 6.16417 3.50161H10.6642C11.3921 3.49445 12.0979 3.75223 12.6498 4.22691C13.2018 4.70159 13.5623 5.36078 13.6642 6.08161C13.8541 7.52171 14.2063 8.9357 14.7142 10.2966C14.916 10.8335 14.9597 11.417 14.84 11.9779C14.7204 12.5389 14.4425 13.0538 14.0392 13.4616L12.1342 15.3666C14.2695 19.1219 17.3788 22.2313 21.1342 24.3666L23.0392 22.4616C23.447 22.0583 23.9619 21.7804 24.5228 21.6608C25.0838 21.5411 25.6673 21.5848 26.2042 21.7866C27.5651 22.2944 28.9791 22.6467 30.4192 22.8366C31.1478 22.9394 31.8133 23.3064 32.289 23.8679C32.7647 24.4293 33.0174 25.146 32.9992 25.8816Z",
    stroke: "#A2CD3A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c04e71b377cc5ed754d99d91934db3ea.svg";
export { ForwardRef as ReactComponent };